import { fieldOrderAnschlussinformationen, formGroupAnschlussinformationen } from "./anschlussinformationen"
import { fieldOrderBackend, formGroupBackend } from "./backend"
import { fieldOrderDienstleistungen, formGroupDienstleistungen } from "./dienstleistungen"
import {
  fieldOrderEnergieUndLademanagementkonzept,
  formGroupEnergieUndLademanagementkonzept,
} from "./energie_und_lademanagementkonzept"
import { fieldOrderEngineeringDokumente, formGroupEngineeringDokumente } from "./engineering_dokumente"
import { fieldOrderInformationenZumStandort, formGroupInformationenZumStandort } from "./informationen_zum_standort"
import { fieldOrderKundendaten, formGroupKundendaten } from "./kundendaten"
import { fieldOrderNetzwerkinformationen, formGroupNetzwerkinformationen } from "./netzwerkinformationen"
import { fieldOrderProjektbeteiligteExtern, formGroupProjektbeteiligteExtern } from "./projektbeteiligte_extern"
import { fieldOrderProjektdaten, formGroupProjektdaten } from "./projektdaten"
import { fieldOrderUmfangDerAngebotsstellung, formGroupUmfangDerAngebotsstellung } from "./umfang_der_angebotsstellung"
import { fieldOrderWartung, formGroupWartung } from "./wartung"

export const fieldOrder = {
  ...fieldOrderProjektdaten,
  ...fieldOrderProjektbeteiligteExtern,
  ...fieldOrderKundendaten,
  ...fieldOrderInformationenZumStandort,
  ...fieldOrderEngineeringDokumente,
  ...fieldOrderUmfangDerAngebotsstellung,
  ...fieldOrderAnschlussinformationen,
  ...fieldOrderDienstleistungen,
  ...fieldOrderBackend,
  ...fieldOrderNetzwerkinformationen,
  ...fieldOrderWartung,
  ...fieldOrderEnergieUndLademanagementkonzept,
}

export const formGroupDefinitions = [
  formGroupProjektdaten,
  formGroupProjektbeteiligteExtern,
  formGroupKundendaten,
  formGroupInformationenZumStandort,
  formGroupEngineeringDokumente,
  formGroupUmfangDerAngebotsstellung,
  formGroupAnschlussinformationen,
  formGroupDienstleistungen,
  formGroupBackend,
  formGroupNetzwerkinformationen,
  formGroupWartung,
  formGroupEnergieUndLademanagementkonzept,
] as const